<template>
   <section>
      <div class="container">
         <div class="row">
            <div>
               <img src="../../assets/img/MFF kedvezményezetti infóblokk-1.jpg" />
            </div>
             <div class="title-header">
               <h3> GINOP Plusz-1.4.3-24/B
                  Hitelprogram keretében
                  munkaerő költségek
                  finanszírozása.</h3>
            </div>
           <div class="ginop-project">
               <h3 class="ginop-project__title">
                  GINOP Plusz-1.4.3-24/B
                  Hitelprogram keretében
                  munkaerő költségek
                  finanszírozása
               </h3>
               <p class="ginop-project__company">
                  BEST-LOG KERESKEDELMI ÉS SZOLGÁLTATÓ
                  KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG
               </p>

               <div class="ginop-project__funding">
                  <p class="ginop-project__label">
                     Visszatérítendő hitel összege:
                  </p>
                  <p class="ginop-project__amount">
                     50 millió forint
                  </p>
               </div>

               <div class="ginop-project__footer">
                  <p class="ginop-project__thanks">
                     KÖSZÖNJÜK A MAGYAR KORMÁNY ÉS AZ EURÓPAI UNIÓ TÁMOGATÁSÁT!
                  </p>
                  <p class="ginop-project__program">
                     Gazdaságfejlesztési és Innovációs Operatív Program Plusz
                  </p>
               </div>
            </div>
            <div class="title-header">
               <h3>Modern üzleti és termelési kihívásokhoz való alkalmazkodást segítő fejlesztés a BEST-LOG Kft-nél.</h3>
            </div>
            <div class="title-desc">
               <ul class="ul-support">
                  <li>Projekt azonosító száma: GINOP_PLUSZ-1.2.1-21-2021-02060</li>
                  <li>Támogatás összege: 35 918 895 Ft</li>
                  <li>Támogatási arány (%) 70</li>
               </ul>
               <p class="justify-p">
                  A BEST-LOG Kft. sikerrel pályázott a GINOP_PLUSZ-2.1.1-21-2021-02060 azonosító számú
                  projektjével a „Modern üzleti és termelési kihívásokhoz való alkalmazkodást segítő fejlesztés a BEST-
                  LOG Kft-nél” tárgyú felhívásra. A 35,92 millió forint feltételesen visszatérítendő Európai Uniós
                  támogatású projekt a Széchenyi Terv Plusz program keretén belül valósult meg. A projekt
                  megvalósításának kezdete 2021.10.01., fizikai befejezésének napja 2023.08.31.
               </p>
               <p class="justify-p">
                  A Best-Log Kft. 2009-ben alakult. Kezdetektől fő profilja a gépjármű-kereskedelem és a közúti
                  szállítás, szárazföldi szállítást kiegészítő szolgáltatás és raktározás. Rövid idő alatt a régió vezető
                  szállítmányozó cégévé vált Lakitelek és agglomerációjának igényeit kiszolgálva. A telepen a
                  vállalkozás autóipari szolgáltató egységei és a kft. saját tulajdonú - közel 300 m2-es - épülete
                  található, mely minden infrastruktúrával rendelkezik a technológiai és informatikai fejlesztés
                  szempontjából.
               </p>
               <p class="justify-p">
                  A folyamatos fejlődés és tanulás a vállalat alapértékeivel egyezik, hiszen a Dél-Alföldön lévő
                  mikrovállalkozás fenntartásához elengedhetetlen az a piaci plusz érték hozzáadása, amellyel ez a
                  pályázat segítségre lehet. A pályázat révén megvalósított informatikai fejlesztéssel és új eszközök
                  beszerzésével és munkavállalók képzésével, vevőelégedettség mérésével, a vezető munkatársak
                  személyes kompetenciájának hozzáadott értékével a bevétel jelentős része lett növelhető.  
               </p>
               <p class="justify-p">
                  A GINOP Plusz-1.2.1-21 pályázat során, Lakitelek frekventált ipari részén Európai Uniós szintű
                  gépjárműfenntartó műhely fejlesztéséhez szükséges tárgyi feltételeinek egyes berendezései kerültek
                  beszerzésre. Többek között ST-2024P Lengéscsillapító, HPA B-700 Kerékkiegyensúlyozó, RBT-
                  1013/CP/E személy- és teherfékpad és egyéb garázsipari berendezések. IT eszközök és számviteli,
                  pénzügy és további üzleti hatékonyságot növelő felhőalapú ügyviteli rendszer került bevezetésre. Az
                  elnyert támogatás során a vezető kollégák kompetenciájának fejlesztése is megtörtént.
               </p>
               <p class="justify-p">
                  A fejlesztés eredményeként növekedett a Kft. gazdasági teljesítménye és javult a technológiai
                  felkészültsége, versenyképessége, és az erőforrás hatékonysága ezzel erősödött a vállalkozás
                  gazdasági szerepe a régióban.
               </p>
               <h6>További információ kérhető:</h6>
               <p>Szabó Attila ügyvezető, sajtóreferens</p>
               <p>+36209267359</p>
               <p>bestlog@t-online.hu</p>
            </div>
             <div class="title-header">
               <h3>Teljesítményértékelési rendszer bevezetése</h3>
            </div>
            <div class="truck-button">
               <a class="butn" href="docs/Best-Log_Kft-_Teljesitmenyertekelesi_rendszer_bevezetese_2022.pdf" download>Dokumentum letöltése</a>
            </div>
             
         </div>
      </div>
   
    <div class="ttm-horizontal_sep width-100 "></div>
      <div class="container">
         <div class="row">
            <div class="szechenyi-container">
               <img class="szechenyi-allo" src="../../assets/img/szechenyi_2020_logo_fekvo_color_RGB.jpg" />
               <img src="../../assets/img/1_infoblokk_2020_ERFA_3C.jpg" />
            </div>
            <div class="title-header">
               <h3>A BEST-LOG Kft. napelemes fejlesztése.</h3>
            </div>
            <div class="title-desc">
               <ul class="ul-support">
                  <li>Projekt azonosító száma: GINOP-4.1.4-19-2020-02351</li>
                  <li>Támogatás összege: 3.000.250 Ft</li>
                  <li>Támogatási arány (%) 70</li>
               </ul>
               <p class="justify-p">
                 „A BEST-LOG Kft. napelemes fejlesztése” című és GINOP-4.1.4-19-2020-02351 kódszámú („Megújuló energia
                  használatát, energiahatékonyság növelését célzó épületenergetikai fejlesztések támogatása” kiírás) pályázattal a
                  BEST-LOG Kft. 3.000.250,- Ft vissza nem térítendő támogatást nyert el a nettó 5.455.000,- Ft összegű beruházása
                  megvalósításához.

               </p>
               <p class="justify-p">
                  A 6065 Lakitelek, Széchenyi körút 160. (Hrsz. 1300) cím alatt található épületen 20 kVA csatlakozási teljesítményű
                  és 20,625 kWp napelem panel összteljesítményű napelemes rendszer telepítése történt meg. A teljes fogyasztás
                  22.768 kWh/év, melyet 99,64%-kal csökkent a megvalósított napelemes rendszer, amellett, hogy CO2 kibocsájtás
                  csökkenést (17,07 tonna/év), illetőleg költségmegtakarítást is eredményez. A kivitelezés 2021.03.11. és
                  2021.03.30. között történt.

               </p>
               <p class="justify-p">
                 A vállalkozás célja, hogy a termelés hatékonyságát maximalizálja, melybe beleértendő, hogy a kor legmagasabb
                  technológiai színvonalú eszközeivel végezze a munkát, és a környezettudatosságra is komoly hangsúlyt fektessen.
                  A beruházás e céloknak messzemenőkig megfelel.
                  A vállalkozás az eddigi működése során is jelentős saját erővel törekedett a céljai elérésére, melyre jelen pályázat
                  további lehetőséget tudott nyújtani.
               </p>
               
               <h6>További információ kérhető:</h6>
               <p>Szabó Attila ügyvezető, sajtóreferens</p>
               <p>+36209267359</p>
               <p>bestlog@t-online.hu</p>
            </div>
         </div>
      </div>
   </section>
</template>
 
<script>
import { info } from '@/assets/js/company.js'; 
import { domain } from '@/assets/js/domain.js'; 
export default {
  name: 'ImpressumTitle',
  data(){
    return { 
        company:info,
        domain: domain
        } 
  }
}

</script>
<style scoped>
.ginop-project {
  box-sizing: border-box;
  width: 100%;
  max-width: 960px;
  min-width: 0;
  margin: 0 auto 64px;
  padding: 64px 24px 48px;
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  text-align: left;
}

.ginop-project .ginop-project__title {
  margin: 0 0 56px;
  font-family: inherit;
  font-size: clamp(28px, 4.5vw, 54px);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: normal;
  text-transform: none;
  color: #000;
}

.ginop-project .ginop-project__company {
  max-width: 760px;
  margin: 0;
  font-size: clamp(20px, 2.8vw, 30px);
  font-weight: 400;
  line-height: 1.5;
  color: #000;
}

.ginop-project__funding {
  margin-top: 130px;
}

.ginop-project .ginop-project__label {
  margin: 0 0 8px;
  font-size: 22px;
  line-height: 1.4;
  color: #000;
}

.ginop-project .ginop-project__amount {
  margin: 0;
  font-size: clamp(34px, 4vw, 44px);
  font-weight: 700;
  line-height: 1.2;
  color: #0846ad;
}

.ginop-project__footer {
  margin-top: 185px;
}

.ginop-project .ginop-project__thanks,
.ginop-project .ginop-project__program {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.5;
  color: #000;
}

.ginop-project .ginop-project__thanks {
  margin: 0 0 24px;
}

.ginop-project .ginop-project__program {
  margin: 0;
}

@media (max-width: 600px) {
  .ginop-project {
    padding: 32px 16px;
    margin-bottom: 40px;
  }

  .ginop-project .ginop-project__title {
    margin-bottom: 32px;
    overflow-wrap: anywhere;
  }

  .ginop-project__funding {
    margin-top: 56px;
  }

  .ginop-project__footer {
    margin-top: 72px;
  }

  .ginop-project .ginop-project__label,
  .ginop-project .ginop-project__thanks,
  .ginop-project .ginop-project__program {
    font-size: 18px;
  }
}
</style>